import React, { useEffect, useRef, useState } from "react";

const SearchBar = (props) => {
	const { placeholder, onInputChange, SearchBarRef, razCallBack } = props;

	const [IsValue, setIsValue] = useState("");

	const handleInputChange = (event) => {
		const value = event.target.value;
		setIsValue(value);
		onInputChange(value);
	};
	const handleButtonRaz = () => {
		setIsValue("");
		onInputChange("");
		razCallBack();
	};

	useEffect(() => {
		const handleKeyDown = (event) => {
			if (event.key === "Escape") {
				handleButtonRaz();
			}
		};
		document.addEventListener("keydown", handleKeyDown);
		return () => {
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, []);

	const SearchBarRefContainer = useRef();
	useEffect(() => {
		if(SearchBarRef){
			SearchBarRef(SearchBarRefContainer.current);
		}
	}, []);


	return (
		<div className="search-bar" ref={SearchBarRefContainer}>
			<input
				type="text"
				value={IsValue}
				placeholder={placeholder}
				onChange={handleInputChange}
			/>
			<button onClick={handleButtonRaz}>réinitialiser les filtres</button>
		</div>
	);
};

export default SearchBar;
